// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderSpinner_loader__uj0Kw","spin":"LoaderSpinner_spin__MgPKi","loaderSmall":"LoaderSpinner_loaderSmall__9b5pp"};